/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */


import { AssuranceDocumentType } from '../types/assurance';
import { QUESTION } from './terminology';

const mapping: Record<AssuranceDocumentType, string> = {
  basis_of_reporting: 'Basis of Reporting',
  management_statement: 'Management Statement',
  assurance_statement: 'Assurance Statement',
}

export const getAssuranceDocName = (type: AssuranceDocumentType) => {
  return mapping[type] ?? type;
}

export enum AssuranceRoles {
  ADMIN = 'admin',
  USER = 'user',
}

export const NO_ACCESS_MESSAGE = `To access survey details you must either be the survey admin or have survey ${QUESTION.PLURAL} delegated to you. If you believe you should have access to this survey please contact the survey admin.`;

export const statusColumns = {
  notReady: {
    name: 'fa fa-award text-ThemeTextLight',
    text: 'Not ready for Assurance',
    accessor: 'notReady',
  },
  verified: {
    name: 'fa fa-award text-ThemeWarningMedium',
    text: 'Verified by company',
    accessor: 'isVerified',
  },
  rejected: {
    name: 'fa fa-award text-ThemeDangerMedium',
    text: 'Disputed',
    accessor: 'isRejected',
  },
  completed: {
    name: 'fa fa-award text-ThemeSuccessMedium',
    text: 'Assured',
    accessor: 'isCompleted',
  },
};
